import { queryOptions } from '@tanstack/react-query';

import { templatesApi } from './templates.api';

export const templatesOptions = {
  all: () => ['dataHub', 'templates'] as const,
  lists: () => [...templatesOptions.all(), 'list'] as const,
  details: () => [...templatesOptions.all(), 'detail'] as const,
  detail: (id: 'powerQuery' | 'python') => [...templatesOptions.details(), id] as const,

  powerQuery: () =>
    queryOptions({
      queryKey: templatesOptions.detail('powerQuery'),
      queryFn: () => templatesApi.fetchPowerQueryTemplate(),
      staleTime: Infinity
    }),

  python: () =>
    queryOptions({
      queryKey: templatesOptions.detail('python'),
      queryFn: () => templatesApi.fetchPythonTemplate()
    })
};
